import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetApiCourses200,
  GetApiCourses400,
  GetApiCourses401,
  GetApiCourses403,
  GetApiCoursesParams,
  SearchCourseDrafts200Item,
  SearchCourseDrafts400,
  SearchCourseDrafts401,
  SearchCourseDrafts403,
  SearchCourseDraftsParams
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 타입별 강의 목록을 조회합니다.
- ENROLLED: 사용자가 수강 신청한 강의
- MY_PUBLISHED: 현재 사용자가 게시한 강의
- POPULAR: 인기 강의
- ROADMAP: 로드맵 강의
- FORYOU: 추천 강의

 * @summary 강의 목록 조회
 */
export const getApiCourses = (
    params: GetApiCoursesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiCourses200>(
      {url: `/api/courses`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCoursesQueryKey = (params: GetApiCoursesParams,) => {
    return [`/api/courses`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCoursesInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getApiCourses>>, TError = GetApiCourses400 | GetApiCourses401 | GetApiCourses403>(params: GetApiCoursesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCourses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCoursesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCourses>>> = ({ signal }) => getApiCourses(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCourses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCoursesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCourses>>>
export type GetApiCoursesInfiniteQueryError = GetApiCourses400 | GetApiCourses401 | GetApiCourses403

/**
 * @summary 강의 목록 조회
 */
export const useGetApiCoursesInfinite = <TData = Awaited<ReturnType<typeof getApiCourses>>, TError = GetApiCourses400 | GetApiCourses401 | GetApiCourses403>(
 params: GetApiCoursesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCourses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiCoursesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiCoursesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCourses>>, TError = GetApiCourses400 | GetApiCourses401 | GetApiCourses403>(params: GetApiCoursesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCourses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCoursesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCourses>>> = ({ signal }) => getApiCourses(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCourses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCoursesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCourses>>>
export type GetApiCoursesQueryError = GetApiCourses400 | GetApiCourses401 | GetApiCourses403

/**
 * @summary 강의 목록 조회
 */
export const useGetApiCourses = <TData = Awaited<ReturnType<typeof getApiCourses>>, TError = GetApiCourses400 | GetApiCourses401 | GetApiCourses403>(
 params: GetApiCoursesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCourses>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiCoursesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 제목을 기준으로 코스 초안을 검색합니다.
대소문자를 구분하지 않는 부분 일치 검색을 지원합니다.

 * @summary 코스 초안 제목 검색
 */
export const searchCourseDrafts = (
    params: SearchCourseDraftsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SearchCourseDrafts200Item[]>(
      {url: `/api/courses/drafts/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSearchCourseDraftsQueryKey = (params: SearchCourseDraftsParams,) => {
    return [`/api/courses/drafts/search`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchCourseDraftsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof searchCourseDrafts>>, TError = SearchCourseDrafts400 | SearchCourseDrafts401 | SearchCourseDrafts403>(params: SearchCourseDraftsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCourseDrafts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCourseDraftsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCourseDrafts>>> = ({ signal }) => searchCourseDrafts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCourseDrafts>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchCourseDraftsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchCourseDrafts>>>
export type SearchCourseDraftsInfiniteQueryError = SearchCourseDrafts400 | SearchCourseDrafts401 | SearchCourseDrafts403

/**
 * @summary 코스 초안 제목 검색
 */
export const useSearchCourseDraftsInfinite = <TData = Awaited<ReturnType<typeof searchCourseDrafts>>, TError = SearchCourseDrafts400 | SearchCourseDrafts401 | SearchCourseDrafts403>(
 params: SearchCourseDraftsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCourseDrafts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchCourseDraftsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSearchCourseDraftsQueryOptions = <TData = Awaited<ReturnType<typeof searchCourseDrafts>>, TError = SearchCourseDrafts400 | SearchCourseDrafts401 | SearchCourseDrafts403>(params: SearchCourseDraftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchCourseDrafts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCourseDraftsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCourseDrafts>>> = ({ signal }) => searchCourseDrafts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCourseDrafts>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchCourseDraftsQueryResult = NonNullable<Awaited<ReturnType<typeof searchCourseDrafts>>>
export type SearchCourseDraftsQueryError = SearchCourseDrafts400 | SearchCourseDrafts401 | SearchCourseDrafts403

/**
 * @summary 코스 초안 제목 검색
 */
export const useSearchCourseDrafts = <TData = Awaited<ReturnType<typeof searchCourseDrafts>>, TError = SearchCourseDrafts400 | SearchCourseDrafts401 | SearchCourseDrafts403>(
 params: SearchCourseDraftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchCourseDrafts>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchCourseDraftsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



